<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21 26H16V20H21V15H27V20H32V26H27V31H21V26ZM24 4L8 10V22.18C8 32.28 14.82 41.7 24 44C33.18 41.7 40 32.28 40 22.18V10L24 4ZM36 22.18C36 30.18 30.9 37.58 24 39.84C17.1 37.58 12 30.2 12 22.18V12.78L24 8.28L36 12.78V22.18Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
